import { Heading, Text } from '@saasalerts/ui'
import { FC } from 'react'
export const ReportHeader: FC<
  React.PropsWithChildren<{ heading: string; subTitle?: string }>
> = ({ children, heading, subTitle }) => {
  return (
    <div className="flex flex-wrap place-items-center gap-3 md:flex-nowrap lg:flex-nowrap print:hidden">
      <div>
        <Heading type="h1">{heading}</Heading>
        {subTitle ? <Text color="secondary">{subTitle}</Text> : ''}
      </div>
      {children}
    </div>
  )
}
